module.exports = __webpack_public_path__ + "static/media/appleNavBar.467c0396.PNG";